// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__hR-NV","size-large":"Avatar_size-large__bKX7S","size-medium":"Avatar_size-medium__FQz-A"};